import { Col, Divider, Row, Table } from "antd";
import React, { useEffect } from "react";
import { CardBody } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import { useAPIUser } from "../../../../_helper/User/UserProvider";
import TaxAmount from "./taxAmount";

const PoDetailsComponent = ({
  details,
  organisationDetails,
  projectDetails,
}) => {
  const columns = [
    {
      title: "BOQ Item",
      key: "boq_item",
      render: (data) => (
        <span>
          {data?.sub_item ? data?.sub_item?.boq_sub_item : data?.item?.boq_item}
        </span>
      ),
    },
    {
      title: "Description",
      key: "item_description",
      render: (data) => (
        <span>
          {data?.sub_item
            ? data?.sub_item?.description
            : data?.item?.description}
        </span>
      ),
    },
    {
      title: "Quantity",
      key: "quantity",
      dataIndex: "quantity",
    },
    {
      title: "Unit",
      key: "unit",
      render: (data) => (
        <span>{data?.sub_item ? data?.sub_item?.unit : data?.item?.unit}</span>
      ),
    },
    {
      title: "Make/Brand",
      key: "brand",
      render: (data) => (
        <span>
          {data?.sub_item ? data?.sub_item?.brand : data?.item?.brand}
        </span>
      ),
    },
    {
      title: "Price",
      key: "unit_po_price",
      render: (data) => (
        <>
          <div>₹{data?.unit_po_price}</div>
          <div>
            Budget : ₹
            {data?.sub_item
              ? data?.sub_item?.budget_price
              : data?.budget_price}
          </div>
        </>
      ),
    },
    {
      title: "Discount",
      key: "discount",
      dataIndex: "discount",
    },
    {
      title: "Tax Value",
      key: "tax_value",
      dataIndex: "tax_value",
    },
    {
      title: "Tax type",
      key: "tax_type",
      // dataIndex: "tax_type",
      render: (data) => (
        <>
          {data?.tax_type == "igst" && "IGST"}
          {data?.tax_type == "cgst_sgst" && "CGST & SGST"}
          {data?.tax_type == "none" && "None"}
        </>
      ),
    },
    {
      title: "Amount",
      key: "amount",
      render: (data) => {
        var total = Number(data?.quantity) * Number(data?.unit_po_price ?? 0);
        var discount = data?.discount;
        var price = total - total * discount * 0.01;
        var tax = data?.tax_value;
        price += price * 0.01 * tax;
        return <span>₹ {(data.total ? data.total : price)?.toFixed(2)}</span>;
      },
    },
  ];

  const taxableAmount = details?.po_items?.reduce((acc, obj) => {
    return (
      acc +
      (obj.quantity * obj.unit_po_price ??
        0 - obj.quantity * obj.unit_po_price ??
        0 * 0.01 * obj.discount ??
        0)
    );
  }, 0);
  const { userDetails, setUserDetails } = useAPIUser();
  return (
    <Col style={{ background: "#fff" }}>
      <CardBody>
        <Row gutter={24}>
          <Col sm={12}>
            <img src={organisationDetails?.organisation_logo} height={80} />
          </Col>
          <Col sm={12}>
            <Row gutter={16} className="mt-3">
              <Col sm={5} md={5}>
                Created By
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={22}>
                    {" " +
                      userDetails.name +
                      " (" +
                      userDetails.contact +
                      ", " +
                      userDetails.email +
                      ")"}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={16} className="mt-3">
              <Col sm={5} md={5}>
                Type of Order
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{details?.type_of_order}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={16} className="mt-3">
              <Col sm={5} md={5}>
                Delivery Date
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{details?.delivery_date}</Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
      <Divider orientation="horizontal" />
      <Row gutter={24} className="mt-3">
        <Col sm={11}>
          <CardBody>
            <div className="">
              <H6>Bill To</H6>
            </div>
            <Row gutter={16}>
              <Col sm={5} md={5}>
                Name
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{organisationDetails?.name}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col sm={5} md={5}>
                Address
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{details?.gst?.address}</Col>
                </Row>
              </Col>
            </Row>
            {/* <Row gutter={16} >
                      <Col sm={5} md={5}>
                        PIN Code
                      </Col>
                      <Col sm={19} md={19}>
                        <Row>
                          <Col sm={1}>:</Col>
                          <Col sm={11}></Col>
                        </Row>
                      </Col>
                    </Row> */}
            <Row gutter={16}>
              <Col sm={5} md={5}>
                GST
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{details?.gst?.label}</Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Col>
        <Col>
          <Divider type="vertical" style={{ height: "100%" }} />
        </Col>
        <Col sm={11}>
          <CardBody>
            <div className="">
              <H6>Vendor Details</H6>
            </div>
            <Row gutter={24} className="">
              <Col sm={7} md={7}>
                Vendor Name
              </Col>
              <Col sm={17} md={17}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{details?.vendor?.name}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={24} className="">
              <Col sm={7} md={7}>
                Address
              </Col>
              <Col sm={17} md={17}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={23}>{details?.vendor?.billing_address}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={24} className="">
              <Col sm={7} md={7}>
                Vendor Code
              </Col>
              <Col sm={17} md={17}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={23}>{details?.vendor?.vendor_code}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={24} className="">
              <Col sm={7} md={7}>
                Contact Details
              </Col>
              <Col sm={17} md={17}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={23}>
                    {details?.vendor?.contact}, {details?.vendor?.email}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={24} className="">
              <Col sm={7} md={7}>
                GST
              </Col>
              <Col sm={17} md={17}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={23}>{details?.vendor?.gst}</Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Col>
      </Row>
      <Divider orientation="horizontal" />
      <CardBody>
        <H6>Ship To</H6>
        <Row gutter={24} className="mt-3">
          <Col sm={12}>
            <Row gutter={16}>
              <Col sm={4} md={4}>
                Name
              </Col>
              <Col sm={20} md={20}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{projectDetails?.project_name}</Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={24} className="mt-3">
          <Col sm={12}>
            <Row gutter={16}>
              <Col sm={4} md={4}>
                Address
              </Col>
              <Col sm={20} md={20}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={23}>
                    {details?.address?.address}, {details?.address?.city}-
                    {details?.address?.pincode}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
      <Divider orientation="horizontal" />
      <CardBody>
        <Table
          dataSource={details?.po_items}
          columns={columns}
          scroll={{ x: "max-content" }}
        />
      </CardBody>
      <Divider orientation="horizontal" />

      <Row>
        <Col sm={11}>
          <CardBody>
            <H6>Payment Terms</H6>
            <CardBody>
              {details?.po_payment_terms?.map((each, ind) => {
                return (
                  <>
                    {each?.percentage > 0 && (
                      <div key={ind}>
                        {each?.term}:{each?.percentage}%
                      </div>
                    )}
                  </>
                );
              })}
            </CardBody>
          </CardBody>
          <Divider orientation="horizontal" />
          <CardBody>
            <H6>Terms and Conditions</H6>
            <CardBody>
              <div className="mb-2">
                {details?.terms_and_condition?.description}
              </div>
              <div className="">
                {details?.terms_and_conditions_description}
              </div>
            </CardBody>
          </CardBody>
        </Col>
        <Col>
          <Divider type="vertical" style={{ height: "100%" }} />
        </Col>
        <Col sm={12}>
          <CardBody>
            <div className="d-flex justify-content-between">
              <div className="">Taxable Amount</div>
              <div className="">{taxableAmount}</div>
            </div>
            <TaxAmount items={details?.po_items} />
          </CardBody>
          <Divider orientation="horizontal" />
          <CardBody>
            {details?.po_additional_charges?.map((each, ind) => (
              <div className="d-flex justify-content-between" key={ind}>
                <div className="">
                  {each?.charge_type + " ("}
                  {each?.tax_type == "igst"
                    ? `${each?.tax_value}% ${
                        each?.tax_type == "igst" ? "IGST" : ""
                      }`
                    : ""}

                  {each?.tax_type == "cgst_sgst"
                    ? `${each?.tax_value / 2}% CGST & `
                    : ""}
                  {each?.tax_type == "cgst_sgst"
                    ? `${each?.tax_value / 2}% SGST`
                    : ""}
                  {each?.tax_type == "None" ? `${each?.tax_value}` + "%" : ""}
                  {")"}
                </div>
                <div className="">
                  {(
                    Number(each?.amount) +
                    Number(each?.amount) * Number(each?.tax_value) * 0.01
                  ).toFixed(2)}
                </div>
              </div>
            ))}
          </CardBody>
          <Divider orientation="horizontal" />
          <CardBody>
            <div className="d-flex justify-content-between">
              <div className="">
                <H6>Total Amount</H6>
              </div>
              <div className="">
                {Number(details?.total_po_raised_amount).toFixed(2)}
              </div>
            </div>
          </CardBody>
        </Col>
      </Row>
      <Divider orientation="horizontal" />
    </Col>
  );
};

export default PoDetailsComponent;
